import {
    LOAD_ORDER_TYPE_MAPPINGS_SUCCESS,
    UPDATE_ORDER_TYPE_MAPPINGS_SUCCESS,
    IMPORT_POS_ORDER_TYPES_SUCCESS,
    CLEAR_ORDER_TYPE_MAPPINGS }from '../../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_ORDER_TYPE_MAPPINGS_SUCCESS:
            return action.payload;
        case UPDATE_ORDER_TYPE_MAPPINGS_SUCCESS:
            return action.payload;
        case IMPORT_POS_ORDER_TYPES_SUCCESS:
            return action.payload;
        case CLEAR_ORDER_TYPE_MAPPINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/pos/OrderTypeMappingsReducer.js